<template>
  <mg-select-tree ref="mgSelectTree" :data="item.data" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
  export default {
    name: 'FormItemSelectTree',
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      item: Object,
      value: Array,
    },
    watch: {
      value(value) {
        if (value === null || value === void 0) {
          this.$refs.mgSelectTree.handleClear()
        }
      },
    },
  }
</script>

<style></style>
